import { Component, OnInit, ChangeDetectionStrategy, ViewChild, TemplateRef } from '@angular/core';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ScriptLoaderService } from 'src/app/_services/script-loader.service';
import { GlobalService } from 'src/app/services/global.service';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  }
};
@Component({
  selector: 'app-patient-schedule',
  templateUrl: './patient-schedule.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // styleUrls: ['../../../../styles.scss'],
  styleUrls: ['./patient-schedule.component.scss']
})
export class PatientScheduleComponent implements OnInit {
  appointmentForm: FormGroup;
  submitted = false;
  event: any
  @ViewChild('modalContent') modalContent: TemplateRef<any>;

  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fa fa-fw fa-pencil"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      }
    },
    {
      label: '<i class="fa fa-fw fa-times"></i>',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter(iEvent => iEvent !== event);
        this.handleEvent('Deleted', event);
      }
    }
  ];

  refresh: Subject<any> = new Subject();

  events: CalendarEvent[] = [
    {
      start: subDays(startOfDay(new Date()), 1),
      end: addDays(new Date(), 1),
      title: 'A 3 day event',
      color: colors.red,
      actions: this.actions,
      allDay: true,
      resizable: {
        beforeStart: true,
        afterEnd: true
      },
      draggable: true
    },
    {
      start: startOfDay(new Date()),
      title: 'An event with no end date',
      color: colors.yellow,
      actions: this.actions
    },
    {
      start: subDays(endOfMonth(new Date()), 3),
      end: addDays(endOfMonth(new Date()), 3),
      title: 'A long event that spans 2 months',
      color: colors.blue,
      allDay: true
    },
    {
      start: addHours(startOfDay(new Date()), 2),
      end: new Date(),
      title: 'A draggable and resizable event',
      color: colors.yellow,
      actions: this.actions,
      resizable: {
        beforeStart: true,
        afterEnd: true
      },
      draggable: true
    }
  ];

  activeDayIsOpen: boolean = true;


  constructor(
    private modal: NgbModal,
    private formBuilder: FormBuilder,
    private _script: ScriptLoaderService,
    private global: GlobalService,

  ) { }

  ngOnInit() {
    this.setForm()
  }
  ngAfterViewInit() {
    this._script.loadScripts('app-patient-schedule',
      ['assets/demo/default/custom/crud/forms/widgets/bootstrap-datepicker.js']);
  }
  setForm() {
    this.appointmentForm = this.formBuilder.group({
      date: ['', Validators.required],
      time: ['', Validators.required],
      location: ['', Validators.required],
      title: ['', Validators.required],
    });
  }

  get f() { return this.appointmentForm.controls; }

  onSubmit() {

  }

  showForm(appointment = '') {

    this.submitted = false;
    if (appointment != '') {
      if (appointment['date'] != null) {
        var date = this.global.setDateNumberDMY(appointment['date'])
      }
      this.appointmentForm = this.formBuilder.group({
        date: [date, Validators.required],
        time: [appointment['time'], Validators.required],
        location: [appointment['location'], Validators.required],
        title: [appointment['title'], Validators.required],
        id: appointment['id']
      });
    }
    else {
      this.setForm()
    }
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      this.viewDate = date;
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd
  }: CalendarEventTimesChangedEvent): void {
    event.start = newStart;
    event.end = newEnd;
    this.handleEvent('Dropped or resized', event);
    this.refresh.next();
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    this.modal.open(this.modalContent, { size: 'lg' });
  }

  addEvent(): void {
    this.submitted = true;

    if (this.appointmentForm.invalid) {
      return;
    }

    (this.appointmentForm.value);
    // this.events.push({
    //   title: 'New event',
    //   start: startOfDay(new Date()),
    //   end: endOfDay(new Date()),
    //   color: colors.red,
    //   draggable: true,
    //   resizable: {
    //     beforeStart: true,
    //     afterEnd: true
    //   }
    // });
    // this.refresh.next();
  }

}
